// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2zl_5"};